import * as React from 'react';
import { useLoc } from '../../hooks/useLoc';
import IcoCookie from 'images/ico_cookie.svg';


export const CookieConsent = ({ onAccept, onDecline }: { onAccept: () => void, onDecline: () => void }) => {
    const loc = useLoc();
    return (<div
        className={`fixed bottom-0 w-full z-[1000] 
        bg-white shadow-zinc-900 shadow-2xl
        px-8 py-5 xm:px-10 xm:py-6 md:py-10`}>

        <div className="flex flex-col md:flex-row md:items-center gap-6">
            <div className="md:basis-8/12 flex flex-col xm:flex-row items-center gap-4 xm:gap-8">
                <img src={IcoCookie} className="w-[32px] ts:w-[40px]"></img>
                <p className="xmmax:text-center">
                    {loc("common.cookieConsent.message")}
                    <a href={'/cookie-policy/'} target={'_blank'} className="text-sh-red"> {loc("common.cookieConsent.link")}</a>
                </p>
            </div>
            <div className="md:basis-4/12 flex flex-col xm:flex-row justify-center items-center gap-4 xm:gap-8 ">
                <button type="button" className="w-48 h-12 border-sh-red border-[1px] rounded-sm" onClick={onDecline} tabIndex={1}>{loc("common.buttons.decline")}</button>
                <button type="button" className="w-48 h-12 bg-sh-red rounded-sm text-white" onClick={onAccept} tabIndex={1}>{loc("common.buttons.accept")}</button>
            </div>

        </div>
    </div>)
}